import { FC,createContext, useContext, useEffect, useState } from "react";
import ProceduresList from "./ProceduresList";
import { ProcedureContextType,ProcedureFormValueType,ProcedureTableType } from "./types";
import { useQuery } from "react-query";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { getProcedureList } from "../../services";
import { useParams } from "react-router-dom";
export const ProcedureContext = createContext<ProcedureContextType>({
    list:[],
    setList:()=>{},
    edit:null,
    setEdit:()=>{},
    refetch:()=>{}
})
const PatientProcedure: FC = () => {
    const [list,setList] = useState<ProcedureTableType[]>([])
    const [edit,setEdit] = useState<ProcedureFormValueType | null>(null)
    const { encounterId } = useParams();
    const { triggerApi } = useContext(HL7ContexTriggerContex);
   const {refetch} = useQuery(["patientProcedureList"],async ()=> await getProcedureList({encounterId:Number(encounterId)}), {
    refetchOnWindowFocus: false,
        onSuccess: (result) => {
          triggerApi();
          if(result.responseIndicator == "success") {
            setList([...result.response]);
          }
        },
        onError:()=>{
          triggerApi();
        }
      });
    useEffect(()=>{
      return ()=>{
         setList([])
         setEdit(null)
      }
    },[])
  return (
    <ProcedureContext.Provider value={{list,setList,edit,setEdit,refetch}}>
        {/* <AddProcedure /> */}
      <ProceduresList />
    </ProcedureContext.Provider>
  );
};

export default PatientProcedure;
